import Component from '@glimmer/component'
import type { SortSpec } from '@blakeelearning/data-tables/utils/data-processor'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Signature {
  Element: HTMLSpanElement
  Args: {
    columnName: string
    sortingPriorityQueue: SortSpec[]
  }
}

export class SortColumnIcon extends Component<Signature> {
  get sortIcon() {
    const icon = this.args.sortingPriorityQueue[0]

    if (icon?.key !== this.args.columnName) {
      return 'phosphor-caret-up-down-fill'
    }

    switch (icon?.sortDirection) {
      case 'asc':
        return 'phosphor-caret-up-fill'
      case 'desc':
        return 'phosphor-caret-down-fill'
      default:
        return 'phosphor-caret-up-down-fill'
    }
  }

  <template><PhosphorIcon @icon={{this.sortIcon}} ...attributes /></template>
}

export default SortColumnIcon
